/* import __COLOCATED_TEMPLATE__ from './cash-app.hbs.js'; */
import Component from '@glimmer/component';
export default class CashApp extends Component {
  get fill() {
    return this.args.fill || 'var(--core-text-10-light-mode-color)';
  }
}